export default __webpack_public_path__ + "fb20cabfc96edf5e76b4b091acb4d4c6.png";